import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import NavbarMobile from "./NavbarMobile";
import { navList } from "./nav";

const Navbar = () => {
  const [customClass, setCustomClass] = useState("nav-shadow");
  const [showMobileNav, setShowMobileNav] = useState(false);

  const navRef = useRef(null);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const navTopPosition = navRef.current.getBoundingClientRect().top;

    if (navTopPosition === 50) {
      setCustomClass("nav-shadow");
    } else if (navTopPosition > 55) {
      setCustomClass("");
    }
  };

  return (
    <nav
      className={`h-[60px] lg:h-[100px] drop-shadow-md lg:drop-shadow-none bg-white flex justify-center items-center sticky top-0 z-50 transition-all duration-300 ${customClass}`}
      ref={navRef}
    >
      <div className="max-w-screen-xl justify-between items-center w-full hidden lg:flex">
        <NavLink className="flex items-center" to="/" aria-label="Clear Choice Cleaning Services home">
          <img
            src="/assets/images/logo/logo_new.webp"
            alt="Clear Choice Cleaning Services"
            width="280"
            height="86"
            className="w-[280px]"
          />
        </NavLink>

        <div className="sm:flex justify-around hidden items-center gap-4 px-4 xl:px-0">
          {navList.map((nav, index) => (
            <NavLink
              key={index}
              to={nav.url}
              className={({ isActive }) =>
                "cursor-pointer text-md py-1 px-2 rounded-md" +
                (isActive
                  ? "text-blue-7 border-blue-6/90 border-b-2"
                  : "text-blue-6 border-transparent border-b-2 hover:text-blue-8")
              }
            >
              {nav.name}
            </NavLink>
          ))}

          <NavLink
            to="/quote"
            className={({ isActive }) =>
              "cursor-pointer text-md text-white linear-stroke drop-shadow bg-blue-7 py-3 px-4 transition-all " +
              (isActive
                ? " text-yellow-200"
                : " hover:text-yellow-200 hover:bg-blue-6")
            }
          >
            Get a Free Quote
          </NavLink>
        </div>
      </div>

      <div className="flex w-full items-center justify-between pr-4 lg:hidden">
        <div className="flex items-center">
          <img
            src="/assets/images/logo/logo_new.webp"
            alt="Clear Choice Cleaning Services"
            width="180"
            height="55"
            className="w-[180px]"
          />
        </div>

        <button
          type="button"
          aria-label="Open menu"
          className="text-blue-6 cursor-pointer transition-all duration-200"
          onClick={() => setShowMobileNav(!showMobileNav)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="22"
            height="22"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      </div>
      <NavbarMobile
        show={showMobileNav}
        handleShow={(value) => setShowMobileNav(value)}
      />
    </nav>
  );
};

export default Navbar;
